export enum YesNoEnum {
  Yes = 'Yes',
  No = 'No',
}
